<template lang="html">
  <div class="row privacy">
    <Header />
    <div class="col-md-1">
    </div>

    <div class="col-sm-10">
      <div class="text-center">
        <h3>{{translation.gdpr.header}}</h3>
        <h3>{{translation.gdpr.secondHeader}}</h3>
        <h4>{{translation.gdpr.thirdHeader}}</h4>
      </div>
      <div class="">
        <p>{{translation.gdpr.p1}}</p>
        <p>{{translation.gdpr.p2}} <a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>.</p>
        <p>{{translation.gdpr.p3}}</p>
        <div class="text-center">
          <h4>{{translation.gdpr.dh}}</h4>
          <p>{{translation.gdpr.dc}}</p>
          <p>{{translation.gdpr.dc1}}</p>
          <p>{{translation.gdpr.dp}}</p>
          <p>{{translation.gdpr.de}}</p>
        </div>
        <p>{{translation.gdpr.p4}}</p>
        <div class="text-left">
          <h4>{{translation.gdpr.h1}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.h2}}</h4>
          <p class="font-italic">{{translation.gdpr.p5}}</p>
        </div>
        <h4>{{translation.gdpr.h3}}</h4>
        <p>{{translation.gdpr.t1}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.t2}}</p>
        <p>{{translation.gdpr.t3}}</p>
        <h4>{{translation.gdpr.h4}}</h4>
        <p>{{translation.gdpr.d1}}</p>
        <p>{{translation.gdpr.d2}}</p>
        <p>{{translation.gdpr.d3}}</p>
        <p>{{translation.gdpr.p6}}</p>
        <h4>{{translation.gdpr.h5}}</h4>
        <p>{{translation.gdpr.p7}}</p>
        <p>{{translation.gdpr.t4}}</p>
        <p>{{translation.gdpr.t5}}</p>
        <p>{{translation.gdpr.t6}}</p>
        <h4>{{translation.gdpr.h6}}</h4>
        <p>{{translation.gdpr.t7}}</p>
        <p>{{translation.gdpr.t8}}</p>
        <p>{{translation.gdpr.t9}}</p>
        <p>{{translation.gdpr.p8}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p9}}</p>
        <h4>{{translation.gdpr.h7}}</h4>
        <p>{{translation.gdpr.t10}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>.</p>
        <p>{{translation.gdpr.t11}}</p>
        <p>{{translation.gdpr.t12}}</p>
        <h4>{{translation.gdpr.h8}}</h4>
        <p>{{translation.gdpr.p10}}</p>
        <p>{{translation.gdpr.p11}}</p>
        <h4>{{translation.gdpr.h9}}</h4>
        <p>{{translation.gdpr.p12}}</p>
        <p>{{translation.gdpr.p13}}</p>
        <h4>{{translation.gdpr.h10}}</h4>
        <p>{{translation.gdpr.p14}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p15}}</p>
        <p>{{translation.gdpr.p16}}</p>
        <h4>{{translation.gdpr.h11}}</h4>
        <p>{{translation.gdpr.p17}}</p>
        <h4>{{translation.gdpr.h12}}</h4>
        <p>{{translation.gdpr.p18}}</p>
        <h4>{{translation.gdpr.h13}}</h4>
        <p>{{translation.gdpr.p19}}</p>
        <h4>{{translation.gdpr.h14}}</h4>
        <p>{{translation.gdpr.p20}}</p>
        <h4>{{translation.gdpr.h15}}</h4>
        <p>{{translation.gdpr.p21}}<a :href="translation.gdpr.site">{{translation.gdpr.site}}</a>{{translation.gdpr.p22}}</p>
        <h4>{{translation.gdpr.h16}}</h4>
        <p>{{translation.gdpr.p23}}</p>
        <p>{{translation.gdpr.t13}}</p>
        <p>{{translation.gdpr.t14}}</p>
        <p>{{translation.gdpr.t15}}</p>
        <p>{{translation.gdpr.t16}}</p>
        <p>{{translation.gdpr.t17}}</p>
        <p>{{translation.gdpr.p24}}</p>
        <p>{{translation.gdpr.t18}}</p>
        <p>{{translation.gdpr.t19}}</p>
        <p>{{translation.gdpr.t20}}</p>
        <h4>{{translation.gdpr.h17}}</h4>
        <p>{{translation.gdpr.p25}}</p>
        <h4>{{translation.gdpr.h18}}</h4>
        <p>{{translation.gdpr.p26}}</p>
        <h4>{{translation.gdpr.h19}}</h4>
        <p>{{translation.gdpr.p27}}</p>
        <h4>{{translation.gdpr.h20}}</h4>
        <p>{{translation.gdpr.p28}}</p>
        <p>{{translation.gdpr.p29}}</p>
        <p>{{translation.gdpr.t21}}</p>
        <p>{{translation.gdpr.t22}}</p>
        <p>{{translation.gdpr.t23}}</p>
        <h4>{{translation.gdpr.h23}}</h4>
        <p>{{translation.gdpr.p40}}</p>
        <h4>{{translation.gdpr.h21}}</h4>
        <p>{{translation.gdpr.p30}}</p>
        <div class="text-center">
          <p>{{translation.gdpr.p31}}</p>
          <p>{{translation.gdpr.p36}}</p>
          <p>{{translation.gdpr.p32}}</p>
          <p>{{translation.gdpr.p33}}</p>
        </div>
        <p>{{translation.gdpr.p34}}</p>
        <p>{{translation.gdpr.p35}}</p>
      </div>
    </div>
    <div class="col-md-1">
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
export default {
  data(){
    return {
      translation: null
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  components: {
    Header
  }
}
</script>

<style lang="css" scoped>
#app .privacy{
  background: #fff;
  margin-bottom: 3em;
}
#app .privacy h3{
  text-align: center;
}
#app .privacy h4{
  margin-top: 2em;
}
#app .privacy {
  text-align: left;
}
.privacy .font-italic {
  font-style: italic;
}

</style>
